import PropTypes from 'prop-types'
import useScheduleCallback from './useScheduleCallback'
import { useTranslation } from 'react-i18next'
import { PopoverList, PopTitle, PopItem } from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/styled-components'

const ScheduleCallbackPopOverContent = ({version}) => {
  const { t } = useTranslation()
  const {
    hasUpcoming,
    upcomingItems,
    popOverTitleKey
  } = useScheduleCallback(version)

  const items = Array.isArray(upcomingItems) ? upcomingItems : []

  if (!hasUpcoming || !items.length) return null

  return (
    <PopoverList>
      <PopTitle>{t(popOverTitleKey)}</PopTitle>

      {hasUpcoming && upcomingItems.map((item) => {
        const scheduleAtDate = item?.scheduledAt ? new Date(item.scheduledAt) : null
        const scheduleAtDateString = scheduleAtDate ? scheduleAtDate.toLocaleString() : '-'
          return (
             <PopItem key={item.id}>
              <div>{scheduleAtDateString}</div>
              {item.contactPhone && <div>{item.contactPhone}</div>}
              {item.contactEmail && <div>{item.contactEmail}</div>}
             </PopItem>
          )
      })}
    </PopoverList>
  )
}

ScheduleCallbackPopOverContent.propTypes = {
  version: PropTypes.string,
}

export default ScheduleCallbackPopOverContent
